// Synthesized incoming-call ringtone (Web Audio — no asset needed). A classic
// North-American phone ring (440 Hz + 480 Hz dual tone) with a ring/pause cadence,
// loud and looping so the agent can't miss an inbound call. Returns a stop() function.
export const startIncomingRing = (): (() => void) => {
  try {
    const Ctx = window.AudioContext || (window as any).webkitAudioContext
    if (!Ctx) return () => {}
    const ctx = new Ctx()
    if (ctx.state === 'suspended') ctx.resume().catch(() => {})
    let stopped = false
    let timer = 0

    // One ring burst = 440 Hz + 480 Hz superimposed for ~1.2 s (the characteristic
    // telephone "ring" warble), shaped with a soft attack/decay.
    const ringBurst = () => {
      const t0 = ctx.currentTime + 0.02
      const dur = 1.2
      const master = ctx.createGain()
      master.connect(ctx.destination)
      master.gain.setValueAtTime(0.0001, t0)
      master.gain.exponentialRampToValueAtTime(0.6, t0 + 0.06) // loud
      master.gain.setValueAtTime(0.6, t0 + dur - 0.1)
      master.gain.exponentialRampToValueAtTime(0.0001, t0 + dur)
      ;[440, 480].forEach((freq) => {
        const osc = ctx.createOscillator()
        osc.type = 'sine'
        osc.frequency.value = freq
        osc.connect(master)
        osc.start(t0)
        osc.stop(t0 + dur + 0.02)
      })
    }

    const loop = () => {
      if (stopped) return
      ringBurst()
      timer = window.setTimeout(loop, 2400) // ~1.2 s ring + ~1.2 s silence
    }
    loop()

    return () => {
      stopped = true
      if (timer) window.clearTimeout(timer)
      ctx.close().catch(() => {})
    }
  } catch {
    return () => {}
  }
}
